// third party imports
import { useMemo } from 'react';
import { AutoComplete } from 'antd';

// internal imports
import './stylesTimezoneDropdown.css';
import { AppStrings } from '../../../utils/constants/AppStrings';
import {
  formatTimezoneDisplay,
  getAvailableTimezones,
} from '../../../utils/dateService';

const TimezoneDropdown = ({
  selectedTimezone,
  onTimezoneChange,
  placeholder = AppStrings.SET_TIME_ZONE,
  className = "",
}) => {
  // Build options from the runtime's IANA list so the live UTC offset
  // (DST-aware) is always rendered alongside the canonical zone name.
  const options = useMemo(
    () =>
      getAvailableTimezones().map((timezone) => ({
        value: timezone,
        label: formatTimezoneDisplay(timezone),
      })),
    [],
  );

  const displayValue = selectedTimezone
    ? formatTimezoneDisplay(selectedTimezone)
    : undefined;

  const handleSelect = (value) => {
    onTimezoneChange(value);
  };

  const filterOption = (inputValue, option) =>
    option.label.toLowerCase().includes(inputValue.toLowerCase());

  return (
    <AutoComplete
      className={`timezone-autocomplete ${className}`}
      classNames={{ popup: "timezone-autocomplete-dropdown" }}
      options={options}
      value={displayValue}
      placeholder={placeholder}
      onSelect={handleSelect}
      filterOption={filterOption}
      allowClear
      onClear={() => onTimezoneChange(null)}
    />
  );
};

export default TimezoneDropdown;
